import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

// Social Layer B — client booking widget + "Mes rendez-vous"
const BookingPage = lazy(() =>
  import('../pages/booking/BookingPage').then((m) => ({ default: m.BookingPage }))
)

export const bookingRoutes: RouteObject[] = [
  { path: 'booking', element: <BookingPage /> },
  { path: 'rendez-vous', element: <BookingPage /> },
]
